import EmployeeModal from './EmployeeModal';

export default EmployeeModal;
